import * as angular from 'angular';
import { ngStorage } from 'ngstorage';

export class SettingsService {
    static $inject = ['$rootScope', '$localStorage'];

    themes = [
        { name: 'primary', sidebar: 'bg-white', sidebarHeader: 'bg-primary bg-light', brand: 'bg-primary', topbar: 'bg-primary' },
        { name: 'purple', sidebar: 'bg-white', sidebarHeader: 'bg-purple bg-light', brand: 'bg-purple', topbar: 'bg-purple' },
        { name: 'success', sidebar: 'bg-white', sidebarHeader: 'bg-success bg-light', brand: 'bg-success', topbar: 'bg-success' },
        { name: 'warning', sidebar: 'bg-white', sidebarHeader: 'bg-warning bg-light', brand: 'bg-warning', topbar: 'bg-warning' },
        { name: 'info', sidebar: 'bg-white', sidebarHeader: 'bg-info bg-light', brand: 'bg-info', topbar: 'bg-info' },
        { name: 'danger', sidebar: 'bg-white', sidebarHeader: 'bg-danger bg-light', brand: 'bg-danger', topbar: 'bg-danger' },
        { name: 'pink', sidebar: 'bg-white', sidebarHeader: 'bg-pink bg-light', brand: 'bg-pink', topbar: 'bg-pink' },
        { name: 'amber', sidebar: 'bg-white', sidebarHeader: 'bg-amber bg-light', brand: 'bg-amber', topbar: 'bg-amber' }
    ];

    constructor(
        private $rootScope: ng.IRootScopeService & any,
        private $localStorage: ngStorage.StorageService
    ) { }

    init() {
        // Global settings

        this.$rootScope.app = {
            name: '', // name title
            description: '',
            year: new Date().getFullYear(),
            views: {
                // animation: 'ng-fadeInLeft2'
            },
            layout: {
                isFixed: false,
                isBoxed: false,
                isDocked: false
            },
            sidebar: {
                isOffscreen: false
            },
            footer: {
                hidden: false
            },
            themeId: 0,
            // default theme
            theme: {
                name: 'primary',
                sidebar: 'bg-white',
                sidebarHeader: 'bg-primary bg-light',
                brand: 'bg-primary',
                topbar: 'bg-primary'
            },
            timeline: {
                typefilter: null,
                categoryfilter: 0,
                categoryfiltername: 'All',
                usecategoryfilter: false,
                hostname: null
            }
        };
    }

    loadAndWatch() {
        // Load current settings from local storage
        if (angular.isDefined(this.$localStorage.settings)) {
            this.$rootScope.app = this.$localStorage.settings;
        } else {
            this.$localStorage.settings = this.$rootScope.app;
        }

        this.$rootScope.$watch('app.layout', () => {
            this.$localStorage.settings = this.$rootScope.app;
        }, true);
    }

    availableThemes() {
        return this.themes;
    }

    setTheme(idx: string) {
        this.$rootScope.app.theme = this.themes[idx];
    }
}

angular.module('app.common').service('settingsService', SettingsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/settings.service.ts